import { ReactComponent as HouseIcon } from 'images/object-house.svg';
import { humanize, moment } from 'utils';

import BaseRealEstateObject from './BaseRealEstateObject';

export default class House extends BaseRealEstateObject {
  constructor({
    sntsType,
    inventoryValue,
    conventionalNumber,
    inventoryNumber,
    inventoryValuationDate,
    ...abstractRealEstateObjectConfig
  }) {
    super(abstractRealEstateObjectConfig);

    this.icon = HouseIcon;
    this.iconClass = 'icon_house';

    Object.assign(this, {
      sntsType,
      inventoryValue,
      conventionalNumber,
      inventoryNumber,
      inventoryValuationDate:
        inventoryValuationDate && moment.fromServerDatetime(inventoryValuationDate),
    });

    Object.assign(this.propertyTitles, {
      type: 'Вид объекта',
      conventionalNumber: 'Условный номер',
      inventoryNumber: 'Инвентарный номер',
      inventoryValue: 'Инвентаризационная стоимость',
      inventoryValuationDate: 'Дата оценки инвентаризационной стоимости',
    });

    Object.assign(this.propertyDisplayValueGetters, {
      area: () => (this.area ? `${this.area}` : this.area),
      type: () => this.sntsType,
      inventoryValuationDate: () => {
        return this.inventoryValuationDate && this.inventoryValuationDate.defaultFormat();
      },
      inventoryValue: () => humanize(this.inventoryValue),
    });
  }

  static typeTitle = 'Недвижимое имущество';

  getTypeTitle() {
    return House.typeTitle;
  }

  isHouse() {
    return true;
  }
}
